import Vue from 'vue'
import moment from 'moment'

Vue.filter('name', obj => {
  return `${obj.firstName} ${obj.lastName}`
})

function formatDate (timestamp) {
  if (typeof timestamp === 'object') {
    return moment(timestamp.toDate()).format('DD/MM/YYYY')
  }
  return Number(timestamp) ? moment.unix(Number(timestamp)).format('DD/MM/YYYY') : ''
}
Vue.filter('formatDate', formatDate)
Vue.filter('unixToDateString', formatDate)

function formatDateTime (timestamp) {
  if (typeof timestamp === 'object') {
    return moment(timestamp.toDate()).format('DD/MM/YYYY h:mma')
  }
  return Number(timestamp) ? moment.unix(Number(timestamp)).format('DD/MM/YYYY h:mma') : ''
}
Vue.filter('formatDateTime', formatDateTime)
Vue.filter('unixToDateTimeString', formatDateTime)

Vue.filter('prettyNumber', number => {
  return Number(Number(number).toFixed(1)).toLocaleString()
})

Vue.filter('prettyUnits', units => {
  switch (units) {
    case 'km': return 'Kilometers'
    case 'hours': return 'Hours'
  }
})

Vue.filter('prettySeconds', seconds => {
  let secs = Number(seconds)
  if (secs > 60) {
    return `${Math.floor(secs / 60)} minutes ${(secs % 60).toFixed(0)} seconds`
  } else {
    return `${secs} seconds`
  }
})

Vue.filter('prettyCoord', coord => {
  return `${coord.lat.toFixed(6)}, ${coord.lng.toFixed(6)}`
})

Vue.filter('unCamel', value => {
  return value.replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
})

Vue.filter('unCamel', value => {
  return value.replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
})
